import { MijnRoute } from '../../mijn-navigatie.model';

export const SELF_SERVICE_CANCELLED_ACCOUNTS: MijnRoute = {
    path: 'opgeheven-rekeningen',
    navigationEvent: 'toOpgehevenRekeningen',
    regex: /^\/zelf-regelen\/opgeheven-rekeningen$/,
    webcomponent: 'mijn-rekeningen-opgeheven-webcomponent'
};
